import { Sport } from '__generated__/globalTypes';
import { useSportContext } from 'contexts/sport';

import { useFeatureFlags } from './useFeatureFlags';

export const useSealingFF = () => {
  const { sport } = useSportContext();
  const {
    flags: {
      useSealing = {
        [Sport.NBA]: false,
        [Sport.FOOTBALL]: false,
        [Sport.BASEBALL]: false,
      },
    },
  } = useFeatureFlags();

  return useSealing[sport];
};
